import { render, staticRenderFns } from "./NavigationContainer.vue?vue&type=template&id=2f3f67f4&scoped=true"
import script from "./NavigationContainer.vue?vue&type=script&lang=js"
export * from "./NavigationContainer.vue?vue&type=script&lang=js"
import style0 from "./NavigationContainer.vue?vue&type=style&index=0&id=2f3f67f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3f67f4",
  null
  
)

export default component.exports